import { render, staticRenderFns } from "./Trustees.vue?vue&type=template&id=77e9e674"
import script from "./Trustees.vue?vue&type=script&lang=js"
export * from "./Trustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports